





















































import { Component, Vue, Prop } from "vue-property-decorator";
import Report from "@/components/template-transfer-pc/report/report.vue";
import { GetContentDetail, EditContent } from "@/request/common";
@Component({
  components: {
    Report,
  },
})
export default class Name extends Vue {
  private ifEdit: any = false;
  private data: any = [];
  private jiBenData: any = {};
  // private isMobile: boolean = window.matchMedia("(max-width: 768px)").matches;
  private isMobile: boolean = true;

  private multiple: any = false; // 是否是批量打印报告
  private ifShowFengmian: any = false;
  private ifShowJiBen: any = true;

  private get latestCollectTime() {
    if (!Array.isArray(this.data) || this.data.length === 0) {
      return "";
    }
    const last = this.data[this.data.length - 1];
    return (last && last.data && last.data.collect_time) || "";
  }


  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private changeData(e: any, index: any) {
    this.data[index].data = e;
    this.$forceUpdate();
  }
  private save() {
    this.data.forEach((ele: any) => {
      const params: any = {
        report: ele.data.report,
      };
      EditContent(this, ele.id, params).then(() => {});
    });
    this.ifEdit = false;
  }
  private getData() {
    const anonymousShareQuery = this.getAnonymousShareQuery();
    this.data.forEach((ele: any) => {
      GetContentDetail(this, ele.id, undefined, anonymousShareQuery).then((res: any) => {
        ele.data = res.data;
        this.$forceUpdate();
      });
    });
  }
  private getAnonymousShareQuery() {
    const access_key = this.$route.query.access_key as string;
    const expire = this.$route.query.expire as string;
    const sign = this.$route.query.sign as string;
    if (access_key && expire && sign) {
      return { access_key, expire, sign };
    }
    const token = localStorage.getItem("token");
    if (token) {
      return undefined;
    }
    return undefined;
  }
  private mounted() {
    if (this.isMobile) {
      this.ifEdit = false;
    }
    if (this.$route.query.ifShowFengmian) {
      this.ifShowFengmian =
        this.$route.query.ifShowFengmian == "是" ? true : false;
    }
    if (this.$route.query.ids) {
      const ids: any = JSON.parse(this.$route.query.ids as any);
      this.data = [];
      ids.forEach((ele: any) => {
        const obj: any = {
          id: ele,
          data: {},
        };
        this.data.push(obj);
      });
      this.getData();
    }
  }
}
